<script>
import { getShortDateDisplay, getDateValue, createOneCheatMeal, readAllCheatMeals, updateOneCheatMeal, deleteOneCheatMeal } from '@/services/CheatMealServices';
export default {
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      // dbase
      allCheatMeals: null,
      // add new craving
      accordionNewCraving: null,
      newCravingText: '',
      todaysDate: {}, // { display: 'Thu, Jun 25', value: '2026-06-25'
      newCravingTrigger: '',
      // edit craving modal
      showEditCravingModal: false,
      editCravingId: '',
      editCravingText: '',
      editCravingTrigger: '',
      editCravingDates: [],
    };
  },
  computed: {
    cIds() {
      return this.allCheatMeals ? Object.keys(this.allCheatMeals) : [];
    },
    canAddNewCraving() {
      return this.newCravingText.trim().length;
    },
    canEditCraving() {
      return this.editCravingText.trim().length > 0;
    },
  },
  methods: {
    async addNewCraving() {
      console.log('*** starting addNewCraving ***');

      const newCheatMeal = {
        craving: this.newCravingText,
        trigger: this.newCravingTrigger,
        cravingDates: [ this.todaysDate ],
      };

      const successfullyCreatedNewCraving = await createOneCheatMeal(this.uId, this.token, newCheatMeal);
      if (successfullyCreatedNewCraving) {
        // add new cheatMeal to the UI
        console.log('*** successfullyCreatedNewCraving ***', successfullyCreatedNewCraving);
        this.allCheatMeals[successfullyCreatedNewCraving.name] = newCheatMeal;
        // clean up the fields
        this.newCravingText = '';
        this.newCravingTrigger = '';
      }

    },

    async iCraveAgain(foodId) {
      console.log('*** starting iCraveAgain(foodId) ***', foodId);

      // const newCravingDates =
      let newCheatMeal = { ...this.allCheatMeals[foodId] };
      newCheatMeal.cravingDates = [ this.todaysDate, ...this.allCheatMeals[foodId].cravingDates ];

      const successfullyUpdatedCheatMeal = await updateOneCheatMeal(this.uId, this.token, foodId, newCheatMeal);
      if (successfullyUpdatedCheatMeal) {
        console.log('*** iCraveAgain() >> response from api ***', successfullyUpdatedCheatMeal);
        this.allCheatMeals[foodId] = newCheatMeal;
      }

    },

    showTheEditCravingModal(cravingId) {
      console.log('*** start showTheEditCravingModal(cravingId) ***', cravingId);
      this.editCravingId = cravingId;
      this.editCravingText = this.allCheatMeals[cravingId].craving;
      this.editCravingTrigger = this.allCheatMeals[cravingId].trigger;
      this.editCravingDates = [ ...this.allCheatMeals[cravingId].cravingDates ];
      this.showEditCravingModal = true;
    },
    removeEditCravingDate(dateIndex) {
      console.log('*** start removeEditCravingDate(dateIndex) ***', dateIndex, this.editCravingDates);

      this.editCravingDates.splice(dateIndex, 1);
    },
    async cancelEditCraving() {
      console.log('*** start cancelEditCraving() ***');

      this.editCravingId = this.editCravingText = this.editCravingTrigger = '';
      this.editCravingDates = [];
      await this.$nextTick();
      this.showEditCravingModal = false;
    },
    async saveEditCraving() {
      // create updated cheatMeal object
      let cm = {
        craving: this.editCravingText.trim(),
      };
      if (this.editCravingTrigger.trim().length > 0) cm.trigger = this.editCravingTrigger.trim();
      if (this.editCravingDates.length > 0) cm.cravingDates = [ ...this.editCravingDates ];
      console.log('*** start saveEditCraving() ***', this.editCravingId, cm);

      // API call
      const successfullyUpdatedACravingCheatMeal = await updateOneCheatMeal(this.uId, this.token, this.editCravingId, cm);
      if (successfullyUpdatedACravingCheatMeal) {
        console.log('*** successfullyUpdatedACravingCheatMeal ***', successfullyUpdatedACravingCheatMeal);
        // update this.allCheatMeals
        this.allCheatMeals[this.editCravingId] = successfullyUpdatedACravingCheatMeal;

        // reset edit vars
        // hide modal
        await this.cancelEditCraving();
      }
    },
    async deleteCraving() {
      console.log('*** start deleteCraving() ***', this.editCravingId);

      await deleteOneCheatMeal(this.uId, this.token, this.editCravingId);
      this.showEditCravingModal = false;
      window.location.reload();
    },

  },
  async created() {
    console.clear();

    // set this.todaysDate {display,value}
    const today = new Date();
    this.todaysDate = {
      display: getShortDateDisplay(today),
      value: getDateValue(today),
    };

    // get this.allCheatMeals
    this.allCheatMeals = await readAllCheatMeals(this.uId, this.token);
    console.log('*** created >> got allCheatMeals ***', this.allCheatMeals);

    if (!this.allCheatMeals) {
      this.accordionNewCraving = 0;
    }

  },
}
</script>

<template>
<div id="cheat-meal-page">

  <!-- PAGE HEADING -->
  <div class="mt-6 mb-2 d-flex justify-space-between align-center">
    <h1>Cheat Meals</h1>
    <p class="me-1"><i>{{todaysDate.display}}</i></p>
  </div>


  <!-- INTRO BLURB -->
  <p class="mx-2 mb-6 text-body-2">
    Sometimes we crave food that isn't in our nutrition plan. So we acknowledge the craving by saving it to this list... Until we can add it to our scheduled menu / nutrition plan (<router-link to="/menus" class="text-black">MenuMaker2000</router-link>). This way we can HIT those macros, baby, <i>and</i> STACK those wins.
  </p>

  <!-- ADD A FOOD CRAVING / CHEAT MEAL -->
  <v-expansion-panels v-model="accordionNewCraving">
    <v-expansion-panel>
      <v-expansion-panel-title class="bg-red-lighten-2 font-weight-bold text-capitalize">+ add a cheat meal / food craving</v-expansion-panel-title>
      <v-expansion-panel-text class="pt-4 pb-2">
        <v-textarea v-model="newCravingText"
                    label="Describe what you want to eat"
                    placeholder="e.g. Burrito de Carnitas, Tres Tacos, y Coca-Cola"
                    variant="outlined"
                    density="comfortable"
                    rows="2"
                    auto-grow
                    clearable
        ></v-textarea>
        <v-textarea v-model="newCravingTrigger"
                    label="What triggered this craving?"
                    placeholder="e.g. I saw a Pizza Hut ad on the TV"
                    variant="outlined"
                    density="comfortable"
                    rows="2"
                    auto-grow
                    clearable
        ></v-textarea>

        <div class="d-flex justify-space-between align-end">
          <p class="text-body-2"><i>{{ todaysDate.value}}</i></p>
          <v-btn @click.prevent="addNewCraving"
                 class="text-grey-darken-3"
                 :color="canAddNewCraving ? 'green-lighten-2' : 'grey-lighten-2'"
                 :disabled="!canAddNewCraving"
          >Add</v-btn>
        </div>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>

  <!-- CARDS - CHEAT MEALS -->
  <div v-if="allCheatMeals" id="all-food-cravings"
       class="my-12 d-flex justify-space-between flex-wrap"
  >
    <v-card v-for="cId in cIds" :key="cId"
            class="card-one-food-craving px-2 pt-2 pb-4 d-flex flex-column justify-space-between border"
            border="lg" elevation="16"
    >
      <!-- craving name -->
      <h3 class="food-craving-title mb-4 allow-new-line text-center font-weight-bold">
        {{ allCheatMeals[cId].craving }}
      </h3>

      <!-- craving accordion -->
      <div class="px-1">
        <v-expansion-panels variant="popout" color="green-lighten-2">
          <v-expansion-panel>
            <v-expansion-panel-title><p class="ps-sm-4 text-white font-weight-bold">CRAVE</p></v-expansion-panel-title>
            <v-expansion-panel-text>
              <!-- i crave again -->
              <div class="my-4 d-flex justify-center">
                <v-btn @click.prevent="iCraveAgain(cId)"
                       variant="outlined"
                       density="comfortable"
                       color="red-lighten-1"
                >I Crave Again</v-btn>
              </div>

              <!-- cravingDates -->
              <p class="mt-12 mb-2 text-center"><b><u>Craving Dates</u></b></p>
              <ol class="ms-8 mb-4">
                <li v-for="d in allCheatMeals[cId].cravingDates" :key="d.value" class="mb-2">
                  <i>{{ d.display }}</i>
                </li>
              </ol>

              <!-- triggers -->
              <p v-if="allCheatMeals[cId].trigger.length" class="mt-8 mb-2 text-center"><b><u>Triggers</u></b></p>
              <p v-if="allCheatMeals[cId].trigger.length" class="allow-new-line mb-4 text-body-2 text-grey-darken-1">
                {{ allCheatMeals[cId].trigger }}
              </p>

              <div class="my-4 d-flex justify-center">
                <v-btn @click.prevent="showTheEditCravingModal(cId)"
                       variant="text"
                       density="compact"
                       color="red-lighten-2"
                       class="text-body-2 text-lowercase font-italic"
                >edit this craving</v-btn>
              </div>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

    </v-card>
  </div> <!-- end cards for allCheatMeals -->


  <!-- MODAL: EDIT CHEAT MEAL -->
  <v-dialog v-model="showEditCravingModal" fullscreen>
    <v-card>
      <v-toolbar>
        <v-btn @click.prevent="showEditCravingModal = false"
               icon="mdi-close"
        ></v-btn>
        <h2>Edit Craving / Cheat Meal</h2>
      </v-toolbar>

      <div id="modal-edit-craving-content" class="pa-4 bg-yellow-lighten-5 h-100">

        <!-- EDIT -->
        <h3 class="mb-2">Craving</h3>
        <v-textarea v-model="editCravingText"
                    label="Describe what you want to eat"
                    placeholder="e.g. Burrito de Carnitas, Tres Tacos, y Coca-Cola"
                    variant="outlined"
                    density="comfortable"
                    rows="2"
                    auto-grow
                    clearable
        ></v-textarea>

        <h3 class="mb-2">Trigger(s)</h3>
        <v-textarea v-model="editCravingTrigger"
                    label="What triggered this craving?"
                    placeholder="e.g. I saw a Pizza Hut ad on the TV"
                    variant="outlined"
                    density="comfortable"
                    rows="2"
                    auto-grow
                    clearable
        ></v-textarea>

        <h3 class="mb-2">Dates of Cravings</h3>
        <ul class="ms-8">
          <li v-for="(date, i) of editCravingDates" :key="i">
            <div class="d-flex">
              <p class="ps-2 pb-2">{{ date.display }}</p>
              <v-btn @click.prevent="removeEditCravingDate(i)"
                     color="red-lighten-2"
                     variant="text"
                     density="compact"
                     class="text-body-2 font-italic"
              >delete</v-btn>
            </div>
          </li>
        </ul>

        <!-- SAVE / CANCEL -->
        <div class="my-12 d-flex flex-column align-center">
          <h3 class="mb-3 font-italic">Does everything look accurate?</h3>
          <v-btn @click.prevent="saveEditCraving"
                 :disabled="!canEditCraving"
                 :color="canEditCraving ? 'green-lighten-1' : 'grey-lighten-1'"
                 class="border"
          >Confirm & Save Craving</v-btn>
          <v-btn @click.prevent="cancelEditCraving"
                 color="red-lighten-2"
                 density="comfortable"
                 class="mt-8 px-2"
          >Cancel</v-btn>
          <div class="my-16 pt-8">
            <v-btn @click="deleteCraving"
                   variant="outlined"
                   color="red-lighten-2"
                   density="compact"
                   class="text-lowercase font-italic"
            >Delete this Cheat Meal craving</v-btn>
          </div>
        </div> <!-- end SAVE/CANCEL -->

      </div>
    </v-card>
  </v-dialog>

</div>
</template>

<style scoped lang="scss">
.allow-new-line { white-space: pre-line; }
#cheat-meal-page {
  max-width: 700px;
  margin: 0 auto;
  padding: 0 8px;



  #all-food-cravings {
    max-width: 650px;
    margin-left: auto;
    margin-right: auto;

    .card-one-food-craving {
      width: 45%;
      margin: 12px 8px;
      min-height: 220px;

      .triggers-container {
        //position: absolute;
        //bottom: 0;
      }
    }

  }
}
</style>
